/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React, { lazy, Suspense } from "react";
import { Redirect, Switch, Route, useLocation } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import {Layout, LayoutSplashScreen} from "../_metronic/layout";

// Lazily loaded major route branches
const BasePage = lazy(() => import("./basepage"));
const AuthPage = lazy(() => import("./modules/Auth/pages/AuthPage").then(module => ({ default: module.AuthPage })));
const Logout = lazy(() => import("./modules/Auth/pages/Logout"));
const ErrorsPage = lazy(() => import("./modules/ErrorsExamples/ErrorsPage"));

const DEEP_LINK_KEY = "fc_deep_link";

export function Routes() {
    const {isAuthorized} = useSelector(
        ({auth}) => ({
            isAuthorized: auth.user != null,
        }),
        shallowEqual
    );
    const location = useLocation();

    // Save intended deep-link before redirecting to login
    if (!isAuthorized
        && !location.pathname.startsWith("/auth")
        && !location.pathname.startsWith("/error")
        && !location.pathname.startsWith("/logout")
        && (location.pathname !== "/" || location.search)) {
        sessionStorage.setItem(DEEP_LINK_KEY, location.pathname + (location.search || ""));
    }

    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <Switch>
                {!isAuthorized ? (
                    /*Render auth page when user at `/auth` and not authorized.*/
                    <Route>
                        <AuthPage />
                    </Route>
                ) : (
                    /*Otherwise redirect to root page (`/`)*/
                    <Redirect from="/auth" to="/"/>
                )}

                <Route path="/error" component={ErrorsPage}/>
                <Route path="/logout" component={Logout}/>


                {!isAuthorized ? (
                    /*Redirect to `/auth` when user is not authorized*/
                    <Redirect to="/auth/login"/>
                ) : (
                    <Layout>
                        <BasePage/>
                    </Layout>
                )}
            </Switch>
        </Suspense>
    );
}
